import React, { useEffect, useState } from 'react';
import i18n from 'i18next';
import { useTranslation, initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend'; // Import the HTTP backend
import LanguageDetector from 'i18next-browser-languagedetector'; // Optional: for language detection

// const resources = {
//     id: {
//         translation: id
//     }
// }

// i18n
//     .use(initReactI18next)
//     .init({
//         resources,
//         lng: "id",
//         interpolation: {
//         escapeValue: false
//         }
//     });

const TRANSLATIONS_URL = '/lang/id.json';

    i18n
  .use(HttpBackend) // Use the HTTP backend to load translations from a server
  .use(LanguageDetector) // Optional: Detect user language (e.g., from browser)
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    fallbackLng: 'en', // Fallback language if translation for 'id' is not found
    debug: true, // Enable debug mode for i18n, useful during development
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    backend: {
    //   loadPath: TRANSLATIONS_URL, // Specify th÷e URL where your translations are located
      loadPath: '/lang/{{lng}}.json',
      // You can also customize how to load multiple languages, e.g.:
      // loadPath: '/locales/{{lng}}/{{ns}}.json',
      // In this case, your `TRANSLATIONS_URL` would point to the directory,
      // and i18next would append `id/translation.json` automatically based on `lng` and default `ns`
    },
    react: {
      useSuspense: false, // Set to true if you are using React.Suspense
    },
  });

export default i18n